/**
 * AdminPanelsPage — quick-launch tiles for the various admin consoles.
 * Pure links; no data layer.
 */

import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  AdminPanelSettings as AdminPanelSettingsIcon,
  OpenInNew as OpenInNewIcon,
} from '@mui/icons-material';

import { PageHeader } from '../components/ui';

const PANELS = [
  { name: 'SoHealthy Admin',      domain: 'https://admin.sohealthy.ai',         color: '#16A34A' },
  { name: 'Spokn Admin',          domain: 'https://admin.spokn.pro',            color: '#9333EA' },
  { name: 'StocksNotifier Admin', domain: 'https://admin.stocksnotifier.com',   color: '#D97706' },
];

const open = (url) => window.open(url, '_blank', 'noopener,noreferrer');

export default function AdminPanelsPage() {
  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, md: 3 } }}>
      <PageHeader
        title="Admin Panels"
        subtitle="Quick-launch tiles for the per-product admin consoles."
      />

      <Grid container spacing={2.5}>
        {PANELS.map((panel) => (
          <Grid item xs={12} sm={6} md={4} key={panel.domain}>
            <Card
              onClick={() => open(panel.domain)}
              sx={{
                cursor: 'pointer',
                transition: 'transform 120ms ease, border-color 120ms ease, box-shadow 120ms ease',
                borderColor: alpha(panel.color, 0.25),
                '&:hover': {
                  transform: 'translateY(-2px)',
                  borderColor: panel.color,
                  boxShadow: (t) => t.shadows[3],
                },
              }}
            >
              <Box
                sx={{
                  height: 4,
                  background: `linear-gradient(90deg, ${panel.color}, ${alpha(panel.color, 0.4)})`,
                }}
              />
              <CardContent>
                <Stack spacing={2} alignItems="flex-start">
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      bgcolor: alpha(panel.color, 0.12),
                      color: panel.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <AdminPanelSettingsIcon />
                  </Box>
                  <Box>
                    <Typography variant="h6" sx={{ color: panel.color, fontWeight: 700 }}>
                      {panel.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {panel.domain.replace('https://', '')}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    endIcon={<OpenInNewIcon />}
                    fullWidth
                    sx={{
                      backgroundColor: panel.color,
                      '&:hover': { backgroundColor: panel.color, opacity: 0.92 },
                    }}
                  >
                    Open
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
